import { http } from '@/utils/axios'

/**
 * @msg: 获取班级学员列表
 */
export function getClassStudentList(data) {
    return http({
        url: http.baseUrl('elAlbum/getStudentPage'),
        method: 'post',
        params: http.params(data)
    })
}

/**
 * @msg: 获取班级用户
 */
 export function getClassUser(data) {
    return http({
        url: http.baseUrl('elAlbum/getUserByAlbum'),
        method: 'post',
        params: http.params(data)
    })
}

/**
 * @msg: 添加班级用户
 */
 export function addClassUser(data) {
    return http({
        url: http.baseUrl('elAlbum/addAlbumUser'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 导入班级用户
 */
 export function importClassUser(data) {
    return http({
        url: http.baseUrl('elAlbum/importExcel'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}